import { useEffect } from 'react';
import ContributionWidget from './pages/ContributionWidget';
import { Route, Routes } from "react-router-dom";
import TagManager from 'react-gtm-module';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
    gtag: Function;
  }
}

function gtag() {window.dataLayer.push(arguments)};

function App() {

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    if (search.get("analyticsMode") !== "POST_MESSAGE") {
      window.dataLayer = window.dataLayer || [];
      window.gtag = gtag;
      const GTM_ID = process.env.REACT_APP_GTM_ID || '';
      const GTM_AUTH = process.env.REACT_APP_GTM_AUTH;
      const GTM_PREVIEW = process.env.REACT_APP_GTM_PREVIEW;
      TagManager.initialize({gtmId: GTM_ID, auth: GTM_AUTH, preview: GTM_PREVIEW});
    }
  }, [])
  
  return (
    <Routes>
      <Route path={"/contribution-widget/:merchantCode"} element={<ContributionWidget />}/>
      <Route path={"/contribution-widget/"} element={<ContributionWidget />}/>
    </Routes>
  );
}

export default App;
